import React, { ReactNode, useEffect, useState } from 'react';
import { Button } from '../../../../../base/components/Button';
import { Modal } from '../../../../../base/components/Modal';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { Country } from '../../../../../base/interfaces/config';
import { __t } from '../../../../../base/utils/t';
import { CountriesSelect } from '../../../../components/CountriesSelect';
import { profileActions } from '../../redux/slice/profileSlice';

interface Props {
    children: ReactNode;
}

export const RecruiterProfileCountriesSelect = ({ children }: Props) => {
    const dispatch = useAppDispatch();
    const {
        recruiterAppProfile: {
            fields: { countries: selectedCountries },
        },
        recruiterApp: {
            config: { countries },
        },
    } = useAppSelector((state) => state);

    const [showModal, setShowModal] = useState(false);
    const [selectedCountriesBeforeSave, setSelectedCountriesBeforeSave] = useState<Country[]>([]);

    useEffect(() => {
        setSelectedCountriesBeforeSave(selectedCountries);
    }, [selectedCountries]);

    const inputChangeHandler = (value: Country[]) => setSelectedCountriesBeforeSave(value);

    const saveHandler = () => {
        dispatch(profileActions.setField({ id: 'countries', value: selectedCountriesBeforeSave }));
        setShowModal(false);
    };

    const closeModalHandler = () => {
        setSelectedCountriesBeforeSave(selectedCountries);
        setShowModal(false);
    };

    return (
        <>
            <div onClick={() => setShowModal(true)}>{children}</div>
            <Modal
                visible={showModal}
                visibilityHandler={closeModalHandler}
                className='recruiter-profile-form__modal'
                containerClassName='recruiter-profile-form__modal-container'
            >
                <CountriesSelect
                    title={__t('В какие страны трудоустраиваете работников?')}
                    className='recruiter-profile-form__modal-select'
                    countries={countries}
                    selectedCountries={selectedCountriesBeforeSave}
                    selectHandler={inputChangeHandler}
                />
                <div className='recruiter-profile-form__modal-buttons'>
                    <Button className='recruiter-profile-form__modal-button' onClick={saveHandler}>
                        {__t('Сохранить')}
                    </Button>
                    <Button className='recruiter-profile-form__modal-button' type='link' onClick={closeModalHandler}>
                        {__t('Отмена')}
                    </Button>
                </div>
            </Modal>
        </>
    );
};
